import { render, staticRenderFns } from "./StatutoryDocuments.vue?vue&type=template&id=bd34f468&"
import script from "./StatutoryDocuments.vue?vue&type=script&lang=js&"
export * from "./StatutoryDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports